import styled from '@emotion/styled';
import type { FC } from 'react';
import { Alert } from 'react-bootstrap';

interface Props {
  errors: Array<Papa.ParseError>;
}

export const ErrorField: FC<Props> = ({ errors }) => {
  if (errors.length === 0) return <></>;
  const maxRow = errors.reduce((pV, e) => Math.max(e.row, pV), 0);

  return (
    <ErrorAlert variant="danger" className="monospace-font">
      <Title>{errors.length} Parsing Errors:</Title>
      {errors.map((e) => (
        <Row key={`${e.row}_${e.type}`}>
          <RowTitle>Row {e.row.toString().padStart(maxRow.toString().length, 0)} | </RowTitle>
          <div>{e.message}</div>
        </Row>
      ))}
    </ErrorAlert>
  );
};

const ErrorAlert = styled(Alert)`
  max-height: 200px;
  overflow: auto;
`;

const Title = styled.div`
  font-weight: 600;
  padding-bottom: 10px;
`;

const RowTitle = styled.div`
  font-weight: 600;
  padding-right: 10px;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  white-space: nowrap;
`;
